import type { Element } from "React";
import { FormattedMessage } from "react-intl";
type Props = {
  className?: string;
};

const IconGraph = (props: Props): Element<"svg"> => (
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 60 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <title>
      <FormattedMessage tagName="span" id="events-graphdetails" />
    </title>
    <desc>Created with Sketch.</desc>
    <g
      id="Artboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" strokeWidth="5">
        <rect
          id="Rectangle"
          stroke="#4DA1A9"
          x="2.5"
          y="2.5"
          width="55"
          height="55"
          rx="8"
        ></rect>
        <path
          d="M5,56 L21,26"
          id="Line"
          stroke="#4CA1A9"
          strokeLinecap="square"
        ></path>
        <path
          d="M37,35 L21,26"
          id="Line-Copy"
          stroke="#4CA1A9"
          strokeLinecap="square"
        ></path>
        <path
          d="M37,35 L55,5"
          id="Line-Copy-2"
          stroke="#4CA1A9"
          strokeLinecap="square"
        ></path>
      </g>
    </g>
  </svg>
);

export default IconGraph;
